import { render, staticRenderFns } from "./EditWelDetail.vue?vue&type=template&id=38af4074&scoped=true"
import script from "./EditWelDetail.vue?vue&type=script&lang=js"
export * from "./EditWelDetail.vue?vue&type=script&lang=js"
import style0 from "./EditWelDetail.vue?vue&type=style&index=0&id=38af4074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af4074",
  null
  
)

export default component.exports